import { AsyncForm } from "src/components/common/forms/AsyncForm.tsx";
import {
	SitePartRevisionEditApi,
	SitePartRevisionEditApi_FormInitData,
} from "src/api/generated/erp/parts/sitePart/api/sitePartRevisionEditApi.ts";
import { FormCommonProps } from "src/components/common/forms/types.ts";
import { FormTextField } from "src/components/common/forms/fields/FormTextField.tsx";
import i18n from "i18next";
import { defineAgentUiContextKey } from "src/components/views/ai/assistant/uiContext/agentUiContextKey.ts";

export interface SitePartRevisionFormProps extends FormCommonProps<number> {
	partRevisionId: number;
}

interface FormValues {
	note: string;
}

export const SitePartRevisionForm = ({ partRevisionId, onCompleted, onFormEdited }: SitePartRevisionFormProps) => {
	return (
		<AsyncForm<SitePartRevisionEditApi_FormInitData, FormValues, number>
			fetch={() => SitePartRevisionEditApi.getFormInitData({ partRevisionId })}
			getDefaultValues={getDefaultValues}
			onCompleted={onCompleted}
			onFormEdited={onFormEdited}
			agentContext={{
				key: defineAgentUiContextKey("erp.parts.sitePartRevision.form"),
				data: { partRevisionId },
			}}
			submit={async (values) => {
				await SitePartRevisionEditApi.update({
					partRevisionId,
					note: values.note,
				});
				return partRevisionId;
			}}
			render={({ control }) => (
				<FormTextField control={control} name={"note"} label={i18n.t("comment")} multiline rows={4} />
			)}
		/>
	);

	function getDefaultValues({ catalogPartRevision }: SitePartRevisionEditApi_FormInitData): FormValues {
		return {
			note: catalogPartRevision.note ?? "",
		};
	}
};
